// REST API endpoint registry. Directory calls only AppSync APIs, so it is
// empty. The default GraphQL endpoint (users-api) is in ./index.ts; the other
// AppSync APIs the app calls are in ./appsync.ts.
type ConfigShape = {
    [key: string]: {
        endpoint: string;
        region: string;
        apiKey?: string;
    };
};

const apiEndpoints: ConfigShape = {};

export const config = apiEndpoints;
